/**
 * TaskStatusRadio Component
 *
 * This component renders a radio group for selecting task status with only Open and None options.
 *
 * Props:
 * - value (array): The currently selected status value.
 * - onChange (function): Callback function to handle changes in selection.
 */

import PropTypes from 'prop-types';
import { Radio } from '@evertrue/et-components';

const TaskStatusRadio = ({ value = [], onChange = () => {}, isTaskFilter = false }) => {
  const hasNoOpenLabel = isTaskFilter ? 'No Open Tasks' : 'No Open Cadence Steps';
  const taskStatusOptions = [
    { label: 'Open', value: ['PAUSED', 'IN_PROGRESS'] },
    {
      label: hasNoOpenLabel,
      value: ['NONE'],
    },
  ];
  return (
    <div className="task-status-radio--box-wrapper">
      {taskStatusOptions.map((option) => (
        <Radio
          key={option.label}
          label={option.label}
          checked={JSON.stringify(value) === JSON.stringify(option.value)}
          onChange={() => onChange(option.value)}
          name="task-status"
        />
      ))}
    </div>
  );
};

TaskStatusRadio.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  isTaskFilter: PropTypes.bool,
};

export default TaskStatusRadio;
